// extracted by mini-css-extract-plugin
export default {"container":"Form_container__VTs6p"};